var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.circle)?_c('circle',{attrs:{"cx":_vm.attrs.cx,"cy":_vm.attrs.cy,"r":_vm.attrs.r,"fill":"black"}}):_c('rect',{attrs:{"fill":"black","x":_vm.attrs.x,"y":_vm.attrs.y,"width":_vm.attrs.width,"height":_vm.attrs.height,"rx":_vm.attrs.rx}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12768cd2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/base/SVGElementMask.vue
// module id = null
// module chunks = 